import React, { useState, useReducer, useEffect, useRef } from "react";
import {
  Button,
  Grid,
  Form,
  Modal,
  Icon,
  Dropdown,
  Message,
  Popup,
} from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
// import { columnDefs, defaultColDef } from "./GridParamsMedicaments/GridParams";
import { QteOptions } from "./DropdownOptions/QteOptions";
import { DureeOptions } from "./DropdownOptions/DureeOptions";
// import moment from "moment";
import CheckboxRenderer from "./CheckboxRenderer";
import moment from "moment";
import { Editor } from "@tinymce/tinymce-react";
import { selectisAuthenticated } from "../../../features/auth/authSlice";

import { useWindowSize } from "react-use";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Medicaments_Counter_Reducer } from "../../../features/counter/counterSlice";


function Medicaments(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const editorRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  // const [PREVonline, setPREVOnline] = useState([]);
  const [NewAVOptions, set_O_Val] = useState(QteOptions);
  const [NewDureeOptions, set_Duree_Options] = useState(DureeOptions);
  const [ordonnance_date, set_ordonnance_date] = useState("");
  const [error, setError] = useState();
  const [visibleMessage] = useState(true);
  const Auth = useSelector(selectisAuthenticated);
  const { height } = useWindowSize();

  const { ID, syncData, userInformation, AuthState } = props;

  let rows, rdv;
  rows = state.rowData2;
  rdv = state.rdv;

  const handleAddition = (e, { value }) => {
    set_O_Val((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };
  const handleAddition_duree = (e, { value }) => {
    set_Duree_Options((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };

  const columnDefs = [
    {
      headerName: "id_medicaments",
      field: "id_medicaments",
      editable: false,
      hide: true,
    },
    {
      checkboxSelection: true,
      floatingFilter: true,
      headerName: "Medicament",
      field: "nom_medicament",
      filterParams: {
        defaultOption: "startsWith",
      },
    },
    {
      checkboxSelection: true,
      floatingFilter: true,
      headerName: "Posologie",
      field: "posologie",
      filterParams: {
        defaultOption: "startsWith",
      },
    },

    // 1ere sous catégorie
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    cellEditor: 'agLargeTextCellEditor',
    cellEditorPopup: true,
    cellEditorParams: {
      maxLength: '3000',
      cols: '40',
      rows: '6',
    },
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  const columnDefs2 = [
    // {
    //     headerName: "Numero",
    //     field: "Numero",
    //     valueGetter: "node.rowIndex + 1",
    //     // hide: true,
    //     // width: 90,
    //     // suppressSizeToFit: false,
    //     // checkboxSelection: true,
    //     // minWidth: 90,
    //     // maxWidth: 90,
    // },
    {
      headerName: "id_ordonnance_medicaments",
      field: "id_ordonnance_medicaments",
      editable: false,
      hide: true,
    },
    {
      // checkboxSelection: true,
      // floatingFilter: true,
      headerName: "Medicament",
      field: "medicament",
    },
    {
      headerName: "Qte",
      field: "qte",
    },
    {
      headerName: "Posologie",
      field: "posologie",
    },
    {
      headerName: "duree",
      field: "duree",
    },
    // {
    //     headerName: "Action", field: "id_medicaments",
    //     cellRenderer: (params) => <div>
    //         <Button positive onClick={() => actionButton(params)}>Ajouter</Button>
    //     </div>
    // },
    // {
    //     headerName: "OD", field: "od",

    // },
    // {
    //     headerName: "OG", field: "og",

    // },
    {
      headerName: "OD",
      field: "od",
      cellRenderer: CheckboxRenderer,
      editable: false,
    },
    {
      headerName: "od bool",
      field: "od",
      hide: true,
    },
    {
      headerName: "OG",
      field: "og",
      cellRenderer: CheckboxRenderer,
      editable: false,
    },
    {
      headerName: "og bool",
      field: "og",
      hide: true,
    },

    // 1ere sous catégorie
  ];

  const defaultColDef2 = {
    sortable: true,
    editable: true,
    cellEditor: 'agLargeTextCellEditor',
    cellEditorPopup: true,
    cellEditorParams: {
      maxLength: '3000',
      cols: '40',
      rows: '6',
    },
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  async function getOneUser() {
    await axios
      .get(`${server}Medicaments/`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch({ type: ACTION.FETCH_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  // INCOMPLETE///////////////////////////////////////////////////////////////////

  // const onValueChanged2 = async () => {
  //   const ss = rows.map((row) => ` ${row.medicament}`);

  //   const cellValue = ss.toString();

  //   const ValuesToCreate = {
  //     fk_id_patientConsul: ID,
  //     created_by: AuthState.user_name,
  //     od: cellValue,
  //     // od: state.od,
  //     fk_id_examen: 15,
  //     // observation: state.observation
  //   };

  //   axios({
  //     method: "post",
  //     responseType: "json",
  //     url: `${server}Consultation`,
  //     data: ValuesToCreate,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then((response) => {
  //       syncData(response.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  // };

  const onValueChanged = async () => {
    // const { idpatient } = req.body
    // const { date_consultation } = req.body
    // const { medicament, qte, posologie, duree, od, og } = item

    const objectToSend2 = {
      rows,
      rdv,
      date_consultation: ordonnance_date,
      userInformation,
      idpatient: ID,
    };
    // second btn logic
    const ss = rows.map((row) => ` ${row.medicament}`);

    const cellValue = ss.toString();

    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      od: cellValue,
      // od: state.od,
      fk_id_examen: 15,
      // observation: state.observation
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}OrdonanceMedoc`,
      data: objectToSend2,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        dispatchRedux(Medicaments_Counter_Reducer(CountersState.Medicaments_Counter + 1));
        dispatch({ type: ACTION.CREATE_ACT_SUCCESS });
        // set_successArchive(true)
        // syncData(response.data)
      })
      .catch((err) => {
        setError(error?.response?.data);
      });

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });

    dispatch({ type: ACTION.OPEN2, size2: "large" });
  };
  ///////////////////////////////////////////////////////////////////////////////////

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    params.api.setRowData(state.rowData);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_medicaments: "",
        nom_medicament: "",
        posologie: "",
      };
      dispatch({
        type: ACTION.MEDICAMENTS_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      // let ModclientArray = {
      //     ...clientArray,
      //     selectionChanged: true
      // }

      dispatch({
        type: ACTION.MEDICAMENTS_TABLE,
        value: clientArray,
      });
    }
  };
  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_ordonnance_medicaments: "",
        medicament: "",
        qte: "",
        posologie: "",
        duree: "",
        od: "",
        og: "",
      };
      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      const allRows = state.rowData2;
      let index = allRows.findIndex((x) => {
        if (
          x.id_ordonnance_medicaments ===
          clientArray.id_ordonnance_medicaments &&
          x.medicament === clientArray.medicament &&
          x.qte === clientArray.qte &&
          x.posologie === clientArray.posologie &&
          x.duree === clientArray.duree &&
          x.od === clientArray.od &&
          x.og === clientArray.og
        ) {
          return true;
        }
      });

      let ModclientArray = {
        ...clientArray,
        index: index,
      };

      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS,
        value: ModclientArray,
      });
    }
  };

  const onCellValueChanged = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Medicaments/${data.id_medicaments}`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.MEDICAMENTS_TABLE,
          value: data,
        });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  // const onCellValueChanged2 = async ({ data }) => {

  // };

  // async function getDate(params) {
  //   let res = params.substring(0, 1);

  //   if (res === "2" && state.id_lunettes && state.fk_id_patientLunette) {
  //     let data = {
  //       created_at: params,
  //       id_lunettes: state.id_lunettes,
  //       fk_id_patientLunette: state.fk_id_patientLunette,
  //       observation: `${state.Antireflet}${state.FiltreBlue}${state.SolaireAntiUV}`,
  //     };

  //     axios({
  //       method: "put",
  //       responseType: "json",
  //       url: `${server}Consultation/LunettesDate`,
  //       data: data,
  //       headers: {
  //         jwtoken: sessionStorage.token,
  //       },
  //     })
  //       .then((response) => {
  //         getOneUser();
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         dispatch({ type: ACTION.CREATE_ERROR });
  //       });
  //   }
  // }

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Medicaments/${state.id_medicaments}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const addItemToOrdonnance = () => {
    let object = {
      id_ordonnance_medicaments: state.id_medicaments,
      medicament: state.nom_medicament,
      qte: state.qte,
      posologie: state.posologie,
      duree: state.duree,
      od: false,
      og: false,
    };
    if (state.id_medicaments) {
      dispatch({ type: ACTION.FETCH_SUCCESS2Mod, payload: object });
      dispatch({ type: ACTION.ORDONANCE_QTE, payload: "" });
      dispatch({ type: ACTION.ORDONANCE_DUREE, payload: "" });
    }

  };

  useEffect(() => {
    let date_ordonnance_medicaments = moment().format("YYYY-MM-DD");
    set_ordonnance_date(date_ordonnance_medicaments);
  }, []);

  const onRemoveSelected = () => {
    let selectedData = gridApi.getSelectedRows();
    gridApi.applyTransaction({ remove: selectedData });
    dispatch({ type: ACTION.FETCH_SUCCESS2Mod2 });
  };
  let componentToShow;
  if (state.rowData2 && state?.rowData2?.length > 0) {
    componentToShow = (
      <>
        {/* <Button
                // floated="left"
                onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
                Imprimer<Icon className="leftSpace" name='print' />
            </Button> */}
        <Button positive onClick={onValueChanged}>
          Valider <Icon className="leftSpace" name="save" />
        </Button>
        {/* <Button positive onClick={onValueChanged2}>
                Valider <Icon className="leftSpace" name='check circle' />
            </Button> */}
      </>
    );
  } else {
    componentToShow = (
      <>
        {/* <Button
                disabled
                onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
                Imprimer<Icon className="leftSpace" name='print' />
            </Button> */}
        <Button disabled positive onClick={onValueChanged}>
          Valider <Icon className="leftSpace" name="save" />
        </Button>
        {/* <Button disabled positive onClick={onValueChanged2}>
                Valider <Icon className="leftSpace" name='check circle' />
            </Button> */}
      </>
    );
  }

  // {
  //     state.rowData2 ?
  //         <>
  //             <Button
  //                 // floated="left"
  //                 onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
  //                 Imprimer<Icon className="leftSpace" name='print' />
  //             </Button>
  //             <Button positive onClick={onValueChanged}>
  //                 Archiver ordonnace <Icon className="leftSpace" name='save' />
  //             </Button>
  //             <Button positive onClick={onValueChanged2}>
  //                 Valider <Icon className="leftSpace" name='check circle' />
  //             </Button>
  //         </>
  //         :
  //         <>
  //             <Button
  //                 disabled
  //                 onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
  //                 Imprimer<Icon className="leftSpace" name='print' />
  //             </Button>
  //             <Button disabled positive onClick={onValueChanged}>
  //                 Archiver ordonnace <Icon className="leftSpace" name='save' />
  //             </Button>
  //             <Button disabled positive onClick={onValueChanged2}>
  //                 Valider <Icon className="leftSpace" name='check circle' />
  //             </Button>
  //         </>
  // }

  const handleDismiss = () => {
    dispatch({ type: ACTION.CREATE_ACT_SUCCESS_CLEAR });
  };
  let ImportantMessage;

  if (state.success && visibleMessage === true) {
    ImportantMessage = (
      <Message
        className="ImportantMessage"
        color="green"
        onDismiss={handleDismiss}
      >
        <Message.Header>Success</Message.Header>
        {state.success}
      </Message>
    );
  }
  const handleDismissERROR = () => {
    setError(null);
  };
  let ImportantERRORMessage;

  if (error && visibleMessage === true) {
    ImportantERRORMessage = (
      <Message
        className="ImportantMessage"
        color="orange"
        onDismiss={handleDismissERROR}
      >
        <Message.Header>Warning!</Message.Header>
        {error}
      </Message>
    );
  }

  let dateModOrdonnance = ordonnance_date;

  if (dateModOrdonnance) {
    dateModOrdonnance = dateModOrdonnance?.split("-");
    dateModOrdonnance = `${dateModOrdonnance[2]}/${dateModOrdonnance[1]}/${dateModOrdonnance[0]}`;
  } else {
    dateModOrdonnance = "";
  }

  let content = "";
  if (state?.rowData2) {
    content = state?.rowData2?.map(
      (row, i) =>
        `<p class="mceNonEditable" style="padding-left: 2rem;line-height: 1;font-size:14px"><span style="text-decoration: underline;"><strong>
          ${i + 1}/ 
          ${row.medicament} ${row.od
          ? row.og
            ? " - Les Deux Yeux"
            : " - Oeil Droit"
          : row.og
            ? " - Oeil Gauche"
            : ""
        }
          ${row.qte ? `- ${row.qte}` : ""}
          </strong></span></p>
        <p class="mceNonEditable" style="padding-left: 3rem;font-size:14px">
          ${row.posologie ? row.posologie : ""}, ${row.duree ? row.duree : ""}
        </p>`
    );
    content = content.join("").toString();
  }

  let headerDate = `<h4 class="mceNonEditable" style="text-align: center;">${dateModOrdonnance ? `Le ${dateModOrdonnance}` : ""
    }</h4>`;
  let headerName = `<h4 class="mceNonEditable" style="text-align: center; margin: 2.5rem;">${userInformation?.civilite} ${userInformation?.nom} ${userInformation?.prenom}</h4>`;

  let rdvFooter = `<p style="padding-left: 2rem;line-height: 1;" class="mceNonEditable">${state.rdv ? `Prochain rendez-vous dans ${state.rdv}` : ""
    }</p>`;

  let description = headerDate + headerName + content + rdvFooter;

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={description}
        init={{
          // selector: "textarea",
          branding: false,
          height: "70vh",
          menubar: false,
          noneditable_editable_class: "mceEditable",
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
            "noneditable",
          ],
          toolbar: " print  ",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm;} body{font-size:16px} ",

          setup: function (editor) {
            editor.on("keydown", function (event) {
              if (event.keyCode === 8 || event.keyCode === 46) {
                const currentLine = editor.selection.getNode();

                // Prevent deletion of non editable text
                if (
                  currentLine.hasAttribute("data-mce-bogus") ||
                  currentLine.className.includes("mceNonEditable")
                ) {
                  event.preventDefault();
                  event.stopPropagation();
                  return false;
                }
              }
            });
          },
        }}
      />
    </div>
  );


  let supprimerDefinitivement, retirerdelordonnance

  if (Auth.role === "admin" && state.id_medicaments) {
    supprimerDefinitivement = <>

      <Button
        negative
        onClick={handleRemoveItem1}
        floated="right"
        icon
      >
        Supprimer définitivement
      </Button>
    </>
  } else {
    supprimerDefinitivement = <>

      <Button
        disabled
        negative
        floated="right"
        icon
      >
        Supprimer définitivement
      </Button>
    </>
  }
  if (state.id_ordonnance_medicaments) {
    retirerdelordonnance =
      <>

        <Button
          color="orange"
          onClick={() => onRemoveSelected()}
          floated="right"
          icon
        >
          Retirer de l'ordonnace
        </Button>
      </>
  } else {
    retirerdelordonnance =
      <>

        <Button disabled color="orange" floated="right" icon>
          Retirer de l'ordonnace
        </Button>
      </>
  }

  return (
    <>
      {/* pills */}
      <Popup
        content="Medicaments"
        trigger={
          <Button
            // 
            color="black"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon name="pills" size="large" className="centerIcon" />
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          <Modal
            onClose={() => dispatch({ type: ACTION.CLOSE2 })}
            size={state.size2}
            open={state.open2}
          >
            <Modal.Header>Ordonnnance</Modal.Header>
            <Modal.Content>{Contents}</Modal.Content>
            <Modal.Actions>
              <Button
                icon="reply"
                content="Retour"
                onClick={() => {
                  dispatch({ type: ACTION.CLOSE });
                  dispatch({ type: ACTION.CLOSE2 });
                }}
              />
            </Modal.Actions>
          </Modal>
          <Grid>
            <Grid.Column width={4}>
              <Form size="small">
                <Form.Field
                  // inline={true}
                  value={state.rdv}
                  onAddItem={handleAddition_duree}
                  search
                  selection
                  // fluid
                  allowAdditions
                  // label='Prochain RDV'
                  control={Dropdown}
                  options={NewDureeOptions}
                  placeholder="Prochain RDV"
                  onChange={(e, data) =>
                    dispatch({
                      type: ACTION.ORDONANCE_RDV,
                      payload: data.value,
                    })
                  }
                // onChange={(e, data) => {
                //     set_Od_Val(data);
                // }}
                />
              </Form>
            </Grid.Column>
            <Grid.Column width={8}>Medicaments</Grid.Column>

            <Grid.Column width={4}>
              <input
                type="date"
                defaultValue={ordonnance_date}
                onChange={(e) => set_ordonnance_date(e.target.value)}
              />
            </Grid.Column>
          </Grid>
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={12}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: height >= 600 ? "30vh" : "48vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData ? state.rowData : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                  enableCellChangeFlash={true}
                ></AgGridReact>
              </div>
              <br />
            </Grid.Column>
            <Grid.Column width={4}>
              <Form>
                {supprimerDefinitivement}
                <Form.Field
                  value={state.qte}
                  onAddItem={handleAddition}
                  search
                  selection
                  fluid
                  allowAdditions
                  label="Qte"
                  control={Dropdown}
                  options={NewAVOptions}
                  placeholder="Qte"
                  onChange={(e, data) =>
                    dispatch({
                      type: ACTION.ORDONANCE_QTE,
                      payload: data.value,
                    })
                  }
                // onChange={(e, data) => {
                //     set_Od_Val(data);
                // }}
                />
                <Form.Field
                  value={state.duree}
                  onAddItem={handleAddition_duree}
                  search
                  selection
                  fluid
                  allowAdditions
                  label="Duree"
                  control={Dropdown}
                  options={NewDureeOptions}
                  placeholder="Duree"
                  onChange={(e, data) =>
                    dispatch({
                      type: ACTION.ORDONANCE_DUREE,
                      payload: data.value,
                    })
                  }
                // onChange={(e, data) => {
                //     set_Od_Val(data);
                // }}
                />

                <Button fluid onClick={addItemToOrdonnance}>
                  <Icon name="chevron down" size="big" />
                </Button>
              </Form>
            </Grid.Column>

            <Grid.Column width={16}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "30vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  // onCellValueChanged={onCellValueChanged2}
                  enableCellChangeFlash={true}
                  components={{
                    CheckboxRenderer: CheckboxRenderer,
                  }}
                ></AgGridReact>
              </div>
              <br />
              <Grid.Row>
                {ImportantMessage}

                {ImportantERRORMessage}
                {retirerdelordonnance}
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour <Icon className="leftSpace" name="reply" />
          </Button>

          {componentToShow}
        </Modal.Actions>
      </Modal >
    </>
  );
}

export default Medicaments;
